import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInsuredPersonCaseState, IPolicy, TError } from './types/InsuredPersonCase-interface';
import { fetchInsuredPersonCase, fetchPolicyDownload } from './actions/fetch-insured-person-case';


const initialState: IInsuredPersonCaseState = {
    Policy: {
        PolicyNumber: "",
        StartDate: "",
        EndDate: "",
        Active: false,
        IndividualLimit: "",
        FullName: "",
        BirthDate: "",
        Gender: "",
        Phone: "",
        Email: "",
        Address: "",
        VIP: false,
        Job: "",
        InsurerName: "",
        HoldingName: "",
        ProgramID: "",
        ResidualPremiumBySpecialProgram: "",
        HasFile: false,
        PersonnelNumber: "",
        ShowGuaranteeLetters: false,
    },
    isLoadingPolicy: false,
    errorPolicy: [],
    lastFetchTime: null,
    isDownload: false,
    errorDownload: [],
    FileData: "",
    FileName: ""
};

export const insuredPersonCase = createSlice({
    name: 'insuredPersonCase',
    initialState,
    reducers: {
        resetListInsuredPersonCase: (state) => {
            state.Policy = initialState.Policy;
        },
        resetFileData: (state) => {
            state.Policy = state.Policy;
            state.isLoadingPolicy = state.isLoadingPolicy;
            state.errorPolicy = state.errorPolicy;
            state.lastFetchTime = state.lastFetchTime;
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInsuredPersonCase.pending, (state) => {
                state.isLoadingPolicy = true;
            })
            .addCase(fetchInsuredPersonCase.fulfilled, (state, action: PayloadAction<{ policy: IPolicy, fetchTime: number }>) => {
                state.isLoadingPolicy = false;
                state.Policy = action.payload.policy;
                state.errorPolicy = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.isDownload = state.isDownload;
                state.errorDownload = state.errorDownload;
                state.FileData = state.FileData;
                state.FileName = state.FileName;
            })
            .addCase(fetchInsuredPersonCase.rejected, (state, action) => {
                state.Policy = initialState.Policy;
                state.isLoadingPolicy = false;
                state.errorPolicy = action.payload as TError;

            })
            .addCase(fetchPolicyDownload.pending, (state) => {
                state.isDownload = true;
            })
            .addCase(fetchPolicyDownload.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownload = false;
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
                state.errorDownload = [];
            })
            .addCase(fetchPolicyDownload.rejected, (state, action) => {
                state.FileData = '';
                state.FileName = '';
                state.isDownload = false;
                state.errorDownload = action.payload as TError;
            });
    },
});

export const { resetListInsuredPersonCase, resetFileData } = insuredPersonCase.actions;
export const insuredPersonCaseReducer = insuredPersonCase.reducer;